import React, { Component } from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import Api from "../../../../../Services/Api";
import {
  contructQueryParam,
  fetchDataAsync,
} from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { INITIAL_PAGINATION } from "../../constant";
import { constructGetDataModalCustomer } from "../../utils";
import { getTableConfigDataCustomer } from "../section/config";
import { defaultTableChange } from "../../../../../modules/custom/customTable";

class ModalDataCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pagination: INITIAL_PAGINATION,
      dataTable: [],
      keyword: null,
    };
  }

  componentDidMount() {
    const { pagination } = this.state;
    this.fetchData(pagination.limit, pagination.page);
  }

  componentDidUpdate(prevProps, prevState) {
    const currPagination = this.state.pagination;
    const prevPagination = prevState.pagination;

    if (
      currPagination.page !== prevPagination.page ||
      currPagination.limit !== prevPagination.limit
    ) {
      this.fetchData(currPagination.limit, currPagination.page);
    }
  }

  fetchData = async (limit, page) => {
    const { setError, onTriggerLoading } = this.props;
    const { keyword } = this.state;

    onTriggerLoading();
    const res = await await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getListCustomerForSalesOrder,
      setError: setError,
      menuName: "Faktur Jual - Data Unit",
      args: contructQueryParam({
        customerName: keyword || "",
        limit: limit || 5,
        page: page || 1,
      }),
    });
    onTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        dataTable: res.data.data?.map((item) =>
          constructGetDataModalCustomer(item)
        ),
        pagination: {
          ...prev.pagination,
          totalData: res.data.totalData || 0,
        },
      }));
    }
  };

  getTableConfig = () => {
    return getTableConfigDataCustomer({
      onSelect: this.handleLoadSelectedData,
    });
  };

  handleLoadSelectedData = (index) => {
    const { dataTable } = this.state;
    const { setValue, onClickClose } = this.props;
    const data = dataTable[index];
    setValue("namaPemilik", data?.name);
    setValue("nik", data?.nik);
    setValue("alamat", data?.address);
    setValue("province", data?.province);
    setValue("kabkot", data?.kabkot);
    setValue("kecamatan", data?.kecamatan);
    setValue("kelurahan", data?.kelurahan);
    setValue("zipcode", data?.zipCode);
    setValue("nomorHp1", data?.hpNumber1);
    setValue("nomorHp2", data?.hpNumber2);
    setValue("memberId", data?.memberId);

    onClickClose();
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        page: 1,
        totalData: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { visible, onClickClose } = this.props;
    const { pagination, dataTable } = this.state;
    return (
      <SimpleModal
        title="List Data Customer/Member"
        visible={visible}
        onClickClose={onClickClose}
        content={
          <ModalContainer>
            <SimpleDataTable
              data={dataTable}
              columns={this.getTableConfig()}
              toCount={pagination.totalData}
              rowsPerPage={pagination.limit}
              page={pagination.page - 1}
              options={defaultTableChange(
                this.handleChangePage,
                this.handleRowsPerPage
              )}
            />
          </ModalContainer>
        }
      />
    );
  }
}

export default ModalDataCustomer;
